// Wallet Types
export const WALLET_TYPE_APPLE = 'wallet/APPLE_PAY';
export const WALLET_TYPE_GOOGLE = 'wallet/GOOGLE_PAY';
export const WALLET_TYPE_SAMSUNG = 'wallet/SAMSUNG_PAY';

// Google sdk constants
export const GOOGLE_PAY_FISERV_WALLET_ID = 'NA';
export const GOOGLE_INTEGRATOR_ID = 'FISERV_GENERIC_SYNCHRONY_1';
export const GOOGLE_HL = 'en-US';
export const GOOGLE_WALLET_BUTTON_ID = 'googlePayWalletButton';

// Apple sdk constants
export const APPLE_WALLET_BUTTON_ID = 'applePayWalletButton';

// Apple -> VISA, FISERV and MASTERCARD wallet IDs
export const APPLE_PAY_MASTERCARD_WALLET_ID = '50110030273';
export const APPLE_PAY_VISA_WALLET_ID = '40010030273';
export const APPLE_PAY_FISERV_WALLET_ID = '11110030273';
export const APPLE_PAY_SYF_MASTERCARD_WALLET_ID = '11110030273';

// Google -> VISA and MASTERCARD wallet IDs
export const GOOGLE_PAY_MASTERCARD_WALLET_ID = '50120834693';
export const GOOGLE_PAY_VISA_WALLET_ID = '40010075001';

// SDK country and language integration constants
export const WALLET_COUNTRY_SETTING = 'US';
export const WALLET_LANG_SETTING = 'en';
